module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-p-1080-928da05777cbefc1abe7cc3ee3587100.jpg";